import pages from './pages';
import components from './components';
import validations from './validations.json';
import common from './common.json';
import titles from './titles.json';

export default { pages, components, titles, common, validations };
